export const steps = {
  SELECTION: 'SELECTION',
  PREVIEW: 'PREVIEW',
  FORM: 'FORM',
};
